import { useEffect } from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./pages/Layout";
import Dashboard from "./pages/Dashboard";
import Organizations from "./pages/Organizations";
import OrganizationForm from "./pages/OrganizationForm";
import OrganizationComparison from "./pages/OrganizationComparison";
import Reports from "./pages/Reports";
import ReportEditor from "./pages/ReportEditor";
import Login from "./pages/Login";
import AdminUsers from "./pages/AdminUsers";
import { AuthProvider, useAuth } from "./context/AuthContext";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, isAdmin } = useAuth();
  const loc = useLocation();
  if (user === undefined) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Yükleniyor…</div>;
  }
  if (user === null) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }
  return children;
}

// Admin olmayanlar için sağ tık + devtools kısayolları engelleme
function SecurityGuard() {
  const { user, isAdmin } = useAuth();
  useEffect(() => {
    if (user === undefined || isAdmin) return;
    const onContext = (e) => e.preventDefault();
    const onKey = (e) => {
      // F12
      if (e.key === "F12") { e.preventDefault(); return; }
      // Ctrl/Cmd + Shift + I/J/C (devtools)
      const ctrl = e.ctrlKey || e.metaKey;
      if (ctrl && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) {
        e.preventDefault();
        return;
      }
      // Ctrl/Cmd + U (view source)
      if (ctrl && e.key.toUpperCase() === "U") { e.preventDefault(); return; }
      // Ctrl/Cmd + S (save page)
      if (ctrl && e.key.toUpperCase() === "S") { e.preventDefault(); return; }
    };
    document.addEventListener("contextmenu", onContext);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("keydown", onKey);
    };
  }, [user, isAdmin]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SecurityGuard />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="organizations" element={<Organizations />} />
            <Route path="organizations/new" element={<OrganizationForm />} />
            <Route path="organizations/:id/edit" element={<OrganizationForm />} />
            <Route path="organizations/:id/comparison" element={<OrganizationComparison />} />
            <Route path="reports" element={<Reports />} />
            <Route path="reports/new" element={<ReportEditor />} />
            <Route path="reports/:id" element={<ReportEditor />} />
            <Route path="admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
        <Toaster richColors closeButton position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
